export const defaultWebchatTheme = {
  fontFamily: 'inter',
  primaryColor: '#3B82F6',
  themeMode: 'light',
  variant: 'solid',
  borderRadiusScale: 1,
  showPoweredByBotpress: true,
}
